import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent {

  @Input() icon: string = 'info';
  @Input() title: string = '';
  @Input() showCopy: boolean = false;
  @Input() formattedCopyText: string = '';

  @ViewChild('cardContent') cardContent: ElementRef;

  copied: boolean = false;

  constructor(private snackBar: MatSnackBar) { }

  static getCleanText(el: any): string {
    const clone = el.cloneNode(true);
    const icons = clone.querySelectorAll('mat-icon');
    for (let i = 0; i < icons.length; i++) {
      icons[i].parentNode.removeChild(icons[i]);
    }
    return clone.innerText.trim();
  }

  copyText(): void {
    let text = '';
    if (this.formattedCopyText) {
      text = this.formattedCopyText;
    } else if (this.cardContent) {
      text = InfoCardComponent.getCleanText(this.cardContent.nativeElement);
    } else {
      return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.copied = true;
    this.snackBar.open('Texto copiado al portapapeles', 'Cerrar', { duration: 2000 });
    setTimeout(() => this.copied = false, 2000);
  }
}
